export const DeliveryPartnerEnum = Object.freeze({
  HayPost: 'HayPost',
  MegaMove: 'MegaMove',
  ZZLogistics: 'ZZLogistics',
  YandexExpress: 'YandexExpress',
  CustomDelivery: 'CustomDelivery',
});
